import { restClient } from 'api/rest-client';
import { UserInfoDto } from 'api/types/core/users';

export const getUserInfo = () => {
  return restClient.get<UserInfoDto>('/core/users/me').then((response) => response.data);
};
